// Tracks (per browser) which auctions have had their settings saved, so the first visit can start on the settings page
const keyFor = (eventId: number | string) => 'auctionSettingsSaved:' + eventId

export const markAuctionSettingsSaved = (eventId: number | string) => {
  try {
    localStorage.setItem(keyFor(eventId), 'true')
  } catch (e) {}
}

export const hasSavedAuctionSettings = (eventId: number | string) => {
  try {
    return localStorage.getItem(keyFor(eventId)) === 'true'
  } catch (e) {
    return true
  }
}
